import React from "react";
import PropTypes from "prop-types";
import "./cc-real-world-comp.css";

const decimalFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
});

const realWorldProps = [
  {
    max: 1000,
    price: 4,
    bg: "coffee",
    description: "cups of coffee",
  },
  {
    max: 15000,
    price: 1000,
    bg: "tv",
    description: "big screen TVs",
  },
  {
    max: 70000,
    price: 2000,
    bg: "cruise",
    description: "seven-day cruises",
  },
  {
    max: 600000,
    price: 68500,
    bg: "jetpack",
    description: "water jetpacks",
  },
  {
    max: 999999999,
    price: 200000,
    bg: "ferrari",
    description: "new Ferraris",
  },
];

const CcRealWorldComp = ({ totalValue }) => {
  const compItem = realWorldProps.find(rwp => totalValue < rwp.max);
  const compCount = totalValue / compItem.price;

  const compIcons = [];
  for (var ci = 0; ci < compCount; ci++) {
    if (ci + 1 < compCount) {
      compIcons.push(
        <div
          className={`real-world-bg real-world-bg-${compItem.bg}`}
          key={ci}
        />
      );
    } else {
      compIcons.push(
        <div
          className={`real-world-bg real-world-bg-${compItem.bg}`}
          style={{ width: 64.0 * (compCount - ci) }}
          key={ci}
        />
      );
    }
  }

  return (
    <div className="cf fl w-100 tc f3 pv3">
      <p>
        That&apos;s like {decimalFormatter.format(compCount)}{" "}
        {compItem.description}!
      </p>
      <div>{compIcons}</div>
    </div>
  );
};

CcRealWorldComp.propTypes = {
  totalValue: PropTypes.number.isRequired,
};

export default CcRealWorldComp;



// WEBPACK FOOTER //
// ./src/cc-real-world-comp.jsx